<script setup lang="ts">
</script>

<template>
    <section>
        <div class="async-loader-animation-container">
            <div class="spinning-dot"></div>
        </div>
    </section>
</template>
